import { render } from "./IconReference.vue?vue&type=template&id=d4d45a26"
import script from "./IconReference.vue?vue&type=script&lang=ts"
export * from "./IconReference.vue?vue&type=script&lang=ts"
script.render = render

export default script